import { apiRequest } from '../axiosInstance';
import axiosInstance from '../axiosInstance';
import { WEBHOOK_ENDPOINTS, buildQueryString } from '../endpoints';

const webhookService = {
  // Endpoints
  getEndpoints: async () => {
    return apiRequest(() =>
      axiosInstance.get(WEBHOOK_ENDPOINTS.LIST_ENDPOINTS)
    );
  },

  getEndpointById: async (id) => {
    return apiRequest(() =>
      axiosInstance.get(WEBHOOK_ENDPOINTS.GET_ENDPOINT(id))
    );
  },

  createEndpoint: async (data) => {
    return apiRequest(() =>
      axiosInstance.post(WEBHOOK_ENDPOINTS.CREATE_ENDPOINT, data)
    );
  },

  updateEndpoint: async (id, data) => {
    return apiRequest(() =>
      axiosInstance.put(WEBHOOK_ENDPOINTS.UPDATE_ENDPOINT(id), data)
    );
  },

  deleteEndpoint: async (id) => {
    return apiRequest(() =>
      axiosInstance.delete(WEBHOOK_ENDPOINTS.DELETE_ENDPOINT(id))
    );
  },

  testEndpoint: async (id, eventType, formSchemaId) => {
    const params = {};
    if (eventType) params.eventType = eventType;
    if (formSchemaId) params.formSchemaId = formSchemaId;
    const queryString = buildQueryString(params);
    return apiRequest(() =>
      axiosInstance.post(`${WEBHOOK_ENDPOINTS.TEST_ENDPOINT(id)}${queryString}`)
    );
  },

  regenerateSecret: async (id) => {
    return apiRequest(() =>
      axiosInstance.post(WEBHOOK_ENDPOINTS.REGENERATE_SECRET(id))
    );
  },

  enableEndpoint: async (id) => {
    return apiRequest(() =>
      axiosInstance.post(WEBHOOK_ENDPOINTS.ENABLE_ENDPOINT(id))
    );
  },

  // Deliveries
  getDeliveries: async (params = {}) => {
    const queryString = buildQueryString(params);
    return apiRequest(() =>
      axiosInstance.get(`${WEBHOOK_ENDPOINTS.LIST_DELIVERIES}${queryString}`)
    );
  },

  getDeliveryDetail: async (id) => {
    return apiRequest(() =>
      axiosInstance.get(WEBHOOK_ENDPOINTS.GET_DELIVERY(id))
    );
  },

  // Sample payloads
  getSamplePayload: async (eventType, formSchemaId) => {
    const params = {};
    if (formSchemaId) params.formSchemaId = formSchemaId;
    const queryString = buildQueryString(params);
    return apiRequest(() =>
      axiosInstance.get(`${WEBHOOK_ENDPOINTS.SAMPLE_PAYLOAD(eventType)}${queryString}`)
    );
  },

  // Event types
  getEventTypes: async () => {
    return apiRequest(() =>
      axiosInstance.get(WEBHOOK_ENDPOINTS.EVENT_TYPES)
    );
  },
};

export default webhookService;
